import * as React from 'react';

// Components
import { InputUsername } from '@shopee-user/input';

// Hooks
import { useTranslation } from '@shopee-user/platform';

// Types
import { InputProps } from '@shopee-user/input';

export const MAX_LOGIN_KEY_LENGTH = 128;

function InputAuthKey(props: InputProps) {
  const I18n = useTranslation();
  return (
    <InputUsername
      type="text"
      placeholder={I18n.t('label_auth_phone_number_or_email')}
      showError
      showErrorOutline
      autoFocus
      maxLength={MAX_LOGIN_KEY_LENGTH}
      autoComplete="on"
      {...props}
    />
  );
}

export default InputAuthKey;
